/* Progressive enhancement: all body-area guides remain readable without JS. */
function initializeCareGuides(scope = document) {
  scope.querySelectorAll('[data-jv3-care]').forEach((guide) => {
    if (guide.dataset.jv3Ready) return;
    const tabList = guide.querySelector('[data-jv3-tabs]');
    const tabs = Array.from(guide.querySelectorAll('[data-jv3-tab]'));
    const panels = Array.from(guide.querySelectorAll('[data-jv3-panel]'));
    if (!tabList || !tabs.length || tabs.length !== panels.length) return;
    const select = (index, focus = false) => {
      tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[position].hidden = !active;
      });
      if (focus) tabs[index].focus();
    };
    tabList.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        select(next, true);
      });
    });
    guide.addEventListener('shopify:block:select', (event) => {
      const index = panels.findIndex((panel) => panel.dataset.jv3Panel === event.detail?.blockId);
      if (index !== -1) select(index);
    });
    select(0);
    tabList.hidden = false;
    guide.dataset.jv3Ready = 'true';
  });
}
initializeCareGuides();
document.addEventListener('shopify:section:load', (event) => initializeCareGuides(event.target));
